// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"a5d1f8b4","513":"a919f5fa","703":"f543c2fd"}[chunkId] + ".chunk.js";
};